import { FC } from 'react'
import cx from 'classnames'

import { AvatarProps } from '../Avatar'
import { FormReviewProps } from '../../form/FormReview'
import { IconProps } from '../Icon'

import * as SC from './styled'

export type AddFeedbackModalProps = {
  className?: string
  avatar: AvatarProps
  formReview: FormReviewProps
  isVisible: boolean
  closeIcon: IconProps
}

const AddFeedbackModal: FC<AddFeedbackModalProps> = ({
  className,
  avatar,
  formReview,
  isVisible,
  closeIcon,
}) => {
  return (
    <SC.AddFeedbackModal
      className={cx('AddFeedbackModal', className)}
      $isVisible={isVisible}
    >
      <SC.Header>
        <SC.MemberAvatar {...avatar} />
        <SC.CloseIcon {...closeIcon} />
      </SC.Header>
      <SC.StarPickerForm {...formReview} />
    </SC.AddFeedbackModal>
  )
}

export default AddFeedbackModal
